/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { BulkDeleteRestService } from '@gh/builder-shared-data';
import { InitViewService } from '@gh/common-shared';
import { SelectionModel, SlicedDataSource } from '@gh/core-data';
import { GridLayoutService } from '@gh/core-ui-grid';
import { Observable } from 'rxjs';
import { BulkDeleteHpFilter, HpBulkDeleteListItem } from './bulk-delete-hp.model';

@Injectable()
export class BulkDeleteHpBusinessService implements InitViewService {
  constructor(private bulkDeleteRest: BulkDeleteRestService,
              private gridLayouts: GridLayoutService) {

  }

  initView(): any {
    return {
      init: this.bulkDeleteRest.init(),
      gridLayout: this.gridLayouts.get('bulkDeleteHousePlans'),
    };
  }

  execute(bulkDeleteFilter: BulkDeleteHpFilter, targetHousePlans: SelectionModel): Observable<void> {
    return this.bulkDeleteRest.execute({ bulkDeleteFilter, targetHousePlans });
  }

  findAllAsDataSource(bulkDeleteFilter: BulkDeleteHpFilter): SlicedDataSource<HpBulkDeleteListItem> {
    return this.bulkDeleteRest.findAllAsDataSource({ filterParameter: { bulkDeleteFilter } });
  }
}
